var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54 7.594a6.469 6.469 0 0112.938 0v.273a2.814 2.814 0 01-.37 5.06 3.944 3.944 0 01-2.806 2.965 1.126 1.126 0 01-1.043.702h-2.25a1.125 1.125 0 010-2.25h2.25c.356 0 .673.165.879.422a2.82 2.82 0 001.743-1.652 2.822 2.822 0 01-.29-.036l-1.258-.222a.41.41 0 01-.332-.474l.835-4.733a.41.41 0 01.473-.332l.477.084a4.781 4.781 0 00-9.554 0l.477-.084a.41.41 0 01.473.332l.835 4.733a.41.41 0 01-.332.474l-1.259.222a2.813 2.813 0 01-1.886-5.21v-.274z",
    fill: "#fff",
    opacity: 0.5
  })));
}
export default __webpack_public_path__ + "static/kf.c2c5cb4e.svg";
export { SvgKf as ReactComponent };